import { defineStore } from 'pinia';
import apiClient from 'api/apiClient.js';

export const useContextStore = defineStore('context', {
    state: () => ({
        user: null,
        authenticated: false,
        locale: 'en',
    }),

    getters: {
        isAuthenticated: (state) => state.authenticated,
    },

    actions: {
        authenticate(user, token) {
            this.user = user;
            this.authenticated = true;
            apiClient.setToken(token);
            return apiClient
                .get('/api/auth')
                .then(() => true)
                .catch((error) => {
                    console.error(error);
                    this.deauthenticate();
                    return false;
                });
        },
        deauthenticate() {
            this.user = null;
            this.authenticated = false;
            apiClient.setToken(null);
        },
    },
});
